import { forwardRef, useImperativeHandle, useState } from 'react';
import { createPortal } from 'react-dom';
import ConfirmDialog from "../components/ui/ConfirmDialog";
import SimpleTable from "../components/ui/SimpleTable";

const UserSitesDialog = forwardRef((props, ref) => {
  const [open, setOpen] = useState(false);
  const [sites, setSites] = useState([]);

  // Expose an `open` method to the parent
  useImperativeHandle(ref, () => ({
    open(siteList) {
      setSites(siteList);
      setOpen(true);
    }
  }));

  if (!open) return null;

  return createPortal(
    <ConfirmDialog
      width="700px"
      open={open}
      title="All Sites"
      message={<SimpleTable
        data={sites}
        columns={{

          site_number: 'Project Id',
          site_name: 'Project Name',

        }}
      />}
      cancelText="Close"
      hideConfirm
      onCancel={() => setOpen(false)}
    />,
    document.body
  );
});

export default UserSitesDialog;